import {FORM_ACCESS_LEVELS} from '../../../../constants/formAccessLevels';
import FORM_AUDIENCE_TYPE from '../../../../constants/FormAudienceType';
import FORM_ASSIGNMENT_TYPE from '../../../../constants/FormAssignmentType';

// The columns a school can add to a form response download. The order here is the order they appear
// in the file, whatever order a member of staff ticked them in. The keys match the placeholders the
// form builder already offers, so a header can never read the same as a question called Year Group.
export const STUDENT_COLUMN_OPTIONS = [
    {key: 'studentForename', label: 'Student Preferred Forename'},
    {key: 'studentLegalSurname', label: 'Student Legal Surname'},
    {key: 'studentUPN', label: 'Student UPN'},
    {key: 'studentDOB', label: 'Student DOB'},
    {key: 'studentSex', label: 'Student Sex'},
    {key: 'studentYearGroup', label: 'Student Year Group'},
    {key: 'studentForm', label: 'Student Form'},
    {key: 'studentHouse', label: 'Student House'},
    {key: 'studentBoarderStatus', label: 'Student Boarder Status'},
    {key: 'studentIntakeGroup', label: 'Student Intake Group'},
    {key: 'studentDistanceFromSchool', label: 'Student Distance from School'},
    {key: 'studentApplicationStatus', label: 'Student Application Status'},
    {key: 'studentEmail', label: 'Student Email'},
    {key: 'studentAddress', label: 'Student Address'},
    {key: 'previousSchoolName', label: 'Previous School Name'},
    {key: 'previousSchoolEmail', label: 'Previous School Email'}
];

export const studentColumnsOfferedToSchool = ({hideBoarderGroups = false, hideHouseGroups = false} = {}) =>
    STUDENT_COLUMN_OPTIONS.filter(option => {
        if (option.key === 'studentBoarderStatus' && hideBoarderGroups) {
            return false;
        }

        if (option.key === 'studentHouse' && hideHouseGroups) {
            return false;
        }

        return true;
    });

// The download offers the columns only where First Name and Last Name hold a child's name.
export const downloadOffersStudentColumns = (form = {}) => {
    const accessLevel = form.accessLevel;
    const audience = form.audience;
    const assignmentType = form.assignmentType;
    const linkToStudents = form.linkToStudents ?? form.LinkToStudents ?? false;

    if (accessLevel === FORM_ACCESS_LEVELS.public) {
        return false;
    }

    if (audience === FORM_AUDIENCE_TYPE.employees && !linkToStudents) {
        return false;
    }

    return !(audience === FORM_AUDIENCE_TYPE.externalUsers &&
        assignmentType === FORM_ASSIGNMENT_TYPE.employees);
};

export const orderStudentColumns = keys => {
    const chosen = new Set(keys || []);

    return STUDENT_COLUMN_OPTIONS
        .filter(option => chosen.has(option.key))
        .map(option => option.key);
};
